package com.arena_web.data.api

import com.arena_web.data.dto.PeopleFeedDto
import com.arena_web.data.dto.PeopleInteractionsCountDto
import com.arena_web.data.dto.PeopleInteractionsDto
import com.arena_web.data.dto.SwipeRequest
import com.arena_web.data.dto.SwipeResponse
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPost
import io.ktor.client.*

class PeopleApi(private val client: HttpClient) {

    suspend fun getFeed(size: Int, offset: Long): ApiResponse<PeopleFeedDto> {
        return client.apiGet(
            "v1/people",
            mapOf("size" to size.toString(), "offset" to offset.toString()),
        )
    }

    /** Public discovery feed — no auth, no swipe-state filtering. */
    suspend fun getPublicFeed(size: Int, offset: Long): ApiResponse<PeopleFeedDto> {
        return client.apiGet(
            "v1/people/public",
            mapOf("size" to size.toString(), "offset" to offset.toString()),
        )
    }

    suspend fun swipe(targetUserId: String, request: SwipeRequest): ApiResponse<SwipeResponse> {
        return client.apiPost("v1/people/$targetUserId/swipe", request)
    }

    suspend fun getInteractions(): ApiResponse<PeopleInteractionsDto> {
        return client.apiGet("v1/people/interactions")
    }

    suspend fun getInteractionsCount(): ApiResponse<PeopleInteractionsCountDto> {
        return client.apiGet("v1/people/interactions/count")
    }
}
